var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.card)?_c('nuxt-link',{staticClass:"flex",attrs:{"to":_vm.$prismic.linkResolver(_vm.card)}},[_c('PrismicImage',{attrs:{"w":"255","h":"155","img":_vm.card.data.image}})],1):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }